import IMG1 from '../../assets/port1.png';
import IMG2 from '../../assets/port2.png';
import IMG3 from '../../assets/port3.png';
import IMG4 from '../../assets/port4.png';
import IMG5 from '../../assets/port5.png';
import IMG7 from '../../assets/omnifood.png';
import IMG8 from '../../assets/ticker.png';
import IMG9 from '../../assets/qr-generator.png';

const data = [
  {
    id: 1,
    image: IMG8,
    title: 'Ticker - Your Time Tracking Companion',
    github: 'https://github.com/proshore/TickerPRO-ProshoreTimeTrackingSystem-FrontendReact',
    demo: 'https://ptt-frontend-dev.proshore.eu/',
  },
  {
    id: 2,
    image: IMG7,
    title: 'Omnifood Nepal',
    github: 'https://github.com/xxfreeshroudxx',
    demo: 'https://omnifood-nepal.netlify.app/',
  },
  {
    id: 3,
    image: IMG5,
    title: 'Music App Landing Page With Proper Animation',
    github: 'https://github.com/xxFREESHROUDxx/music-app-landing-page',
    demo: 'https://cheery-llama-9a816e.netlify.app/',
  },
  {
    id: 4,
    image: IMG1,
    title: 'Simple Todo Web Application',
    github: 'https://github.com/xxFREESHROUDxx/todo-app',
    demo: 'https://sharp-leavitt-a15a28.netlify.app/',
  },
  {
    id: 5,
    image: IMG2,
    title: 'The Ultimate Weather App using Meta-Weather API',
    github: 'https://github.com/xxfreeshroudxx/the-ultimate-weather-app',
    demo: 'https://friendly-mccarthy-aedd65.netlify.app/',
  },
  {
    id: 6,
    image: IMG3,
    title: 'Restaurant Menu App with Proper Billing and Checkout',
    github: 'https://github.com/xxFREESHROUDxx/restaurant-menu-app',
    demo: 'https://frolicking-selkie-a5acc1.netlify.app/',
  },
  {
    id: 7,
    image: IMG4,
    title: 'AppBuzz: An E2EE Chat Application',
    github: 'https://github.com/xxfreeshroudxx',
    demo: 'https://github.com/xxfreeshroudxx',
  },
  {
    id: 8,
    image: IMG9,
    title: 'QR Generator Application',
    github: 'https://github.com/xxFREESHROUDxx/qr-code-generator',
    demo: 'https://qr-generator-nepal.netlify.app/',
  },
];

export default data;
